module.exports = __webpack_public_path__ + "static/media/new_drop_arrow.69fbd147.svg";